export enum ContentSections {
  RegistrationComplete = 'RegistrationComplete',
  RegistrationEmailValidationError = 'RegistrationEmailValidationError',
  RegistrationError = 'RegistrationError',
  RegistrationForm = 'RegistrationForm',
  RegistrationUnavailable = 'RegistrationUnavailable',
}